import React from 'react';
import { TooltipDelay, TooltipHost } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { useStyles } from './TextWithTooltip.styles';

interface TextWithTooltipProps {
  tooltip: string;
  text: string;
}

export const TextWithTooltip: React.FC<TextWithTooltipProps> = ({tooltip, text}) => {
  const tooltipId = useId('tooltip');
  const styles = useStyles();

  return (
    <TooltipHost
      id={tooltipId}
      delay={TooltipDelay.medium}
      tooltipProps={{
        onRenderContent: () => <>{tooltip}</>,
      }}
    >
      <span className={styles.text}>{text}</span>
    </TooltipHost>
  );
}
